export const processError = (error) => {
    return {
        status: false,
        message:
            error?.response?.data?.message ??
            "Ha ocurrido un error al ejecutar la petición",
        data: [],
        errors: error?.response?.data?.errors ?? []
    };
};

export const getHeaders = () => {
    return {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("accessToken"),
    };
};

export const objectToQueryParameters = (params = {}) => {
    const queries = Object
        .entries(params)
        .map(entries => entries.join('='))
        .join('&');

    return queries;
};
